<script setup>

import AccountUnitAnalystAudit from "./accountUnitAnalystAudit.vue";
import AccountUnitUploadInventoryHandStatusAudit from "./accountUnitUploadInventoryHandStatusAudit.vue";
import AccountUnitWriteFinishStatusAudit from "./accountUnitWriteFinishStatusAudit.vue";
import AccountUnitWritePermanentSolutionAudit from "./accountUnitWritePermanentSolutionAudit.vue";
import AfterSalesMinisterAudit from "./afterSalesMinisterAudit.vue";
import MarketEngineerAudit from "./marketEngineerAudit.vue";
import MarketingManagerAudit from "./marketingManagerAudit.vue";
import NormalAudit from "./normalAudit.vue";
import PdiEngineerUploadPdiResultAudit from "./pdiEngineerUploadPdiResultAudit.vue";
import QeAssignAccountUnitAudit from "./qeAssignAccountUnitAudit.vue";
import QeCheckAndUploadBreakPointInfoAudit from "./qeCheckAndUploadBreakPointInfoAudit.vue";
import QeEnsurePermanentSolutionAudit from "./qeEnsurePermanentSolutionAudit.vue";
import QeReasonAnalystAudit from "./qeReasonAnalystAudit.vue";
import QeVehicleDisposalPlanForTheOutputMarketAudit from "./qeVehicleDisposalPlanForTheOutputMarketAudit.vue";
import QualityEngineerCloseAudit from "./qualityEngineerCloseAudit.vue";
import QualityManagerInitiateRecallAudit from "./qualityManagerInitiateRecallAudit.vue";
import QualityReasonAnalystAudit from "./qualityReasonAnalystAudit.vue";
import ReasonAnalystAudit from "./reasonAnalystAudit.vue";
import SolutionAudit from "./solutionAudit.vue";
import QualityManagerUpgradeAudit from "./qualityManagerUpgradeAudit.vue";
</script>

<template>
    <div class="audit-form-main">
      <el-tabs v-model="activeName">
        <el-tab-pane label="accountUnitAnalystAudit" name="accountUnitAnalystAudit">
          <account-unit-analyst-audit  :taskId="taskId"></account-unit-analyst-audit>
        </el-tab-pane>
        <el-tab-pane label="accountUnitUploadInventoryHandStatusAudit" name="accountUnitUploadInventoryHandStatusAudit">
          <account-unit-upload-inventory-hand-status-audit :taskId="taskId"></account-unit-upload-inventory-hand-status-audit>

        </el-tab-pane>
        <el-tab-pane label="accountUnitWriteFinishStatusAudit" name="accountUnitWriteFinishStatusAudit">
          <account-unit-write-finish-status-audit :taskId="taskId"></account-unit-write-finish-status-audit>

        </el-tab-pane>
        <el-tab-pane label="accountUnitWritePermanentSolutionAudit" name="accountUnitWritePermanentSolutionAudit">
          <account-unit-write-permanent-solution-audit :taskId="taskId"></account-unit-write-permanent-solution-audit>

        </el-tab-pane>
        <el-tab-pane label="afterSalesMinisterAudit" name="afterSalesMinisterAudit">
          <after-sales-minister-audit :taskId="taskId"></after-sales-minister-audit>

        </el-tab-pane>
        <el-tab-pane label="marketEngineerAudit" name="marketEngineerAudit">
          <market-engineer-audit :taskId="taskId"></market-engineer-audit>

        </el-tab-pane>
        <el-tab-pane label="marketingManagerAudit" name="marketingManagerAudit">
          <marketing-manager-audit :taskId="taskId"></marketing-manager-audit>
        </el-tab-pane>
        <el-tab-pane label="normalAudit" name="normalAudit">
          <normal-audit :taskId="taskId"></normal-audit>
        </el-tab-pane>
        <el-tab-pane label="pdiEngineerUploadPdiResultAudit" name="pdiEngineerUploadPdiResultAudit">
          <pdi-engineer-upload-pdi-result-audit :taskId="taskId"></pdi-engineer-upload-pdi-result-audit>

        </el-tab-pane>
        <el-tab-pane label="qeAssignAccountUnitAudit" name="qeAssignAccountUnitAudit">
          <qe-assign-account-unit-audit :taskId="taskId"></qe-assign-account-unit-audit>

        </el-tab-pane>
        <el-tab-pane label="qeCheckAndUploadBreakPointInfoAudit" name="qeCheckAndUploadBreakPointInfoAudit">
          <qe-check-and-upload-break-point-info-audit :taskId="taskId"></qe-check-and-upload-break-point-info-audit>

        </el-tab-pane>
        <el-tab-pane label="qeEnsurePermanentSolutionAudit" name="qeEnsurePermanentSolutionAudit">
          <qe-ensure-permanent-solution-audit :taskId="taskId"></qe-ensure-permanent-solution-audit>

        </el-tab-pane>
        <el-tab-pane label="qeReasonAnalystAudit" name="qeReasonAnalystAudit">
          <qe-reason-analyst-audit :taskId="taskId"></qe-reason-analyst-audit>

        </el-tab-pane>
        <el-tab-pane label="qeVehicleDisposalPlanForTheOutputMarketAudit" name="qeVehicleDisposalPlanForTheOutputMarketAudit">
          <qe-vehicle-disposal-plan-for-the-output-market-audit :taskId="taskId"></qe-vehicle-disposal-plan-for-the-output-market-audit>

        </el-tab-pane>
        <el-tab-pane label="qualityEngineerCloseAudit" name="qualityEngineerCloseAudit">
          <quality-engineer-close-audit :taskId="taskId"></quality-engineer-close-audit>

        </el-tab-pane>
        <el-tab-pane label="qualityManagerInitiateRecallAudit" name="qualityManagerInitiateRecallAudit">
          <quality-manager-initiate-recall-audit :taskId="taskId"></quality-manager-initiate-recall-audit>

        </el-tab-pane>
        <el-tab-pane label="qualityReasonAnalystAudit" name="qualityReasonAnalystAudit">
          <quality-reason-analyst-audit :taskId="taskId" ></quality-reason-analyst-audit>
        </el-tab-pane>
        <el-tab-pane label="reasonAnalystAudit" name="reasonAnalystAudit">
          <reason-analyst-audit :taskId="taskId"></reason-analyst-audit>
        </el-tab-pane>
        <el-tab-pane label="solutionAudit" name="solutionAudit">
          <solution-audit :taskId="taskId"></solution-audit>
        </el-tab-pane>
        <el-tab-pane label="qualityManagerUpgradeAudit" name="qualityManagerUpgradeAudit">
          <quality-manager-upgrade-audit :taskId="taskId"></quality-manager-upgrade-audit>
        </el-tab-pane>
      </el-tabs>



    </div>
</template>

<style scoped lang="scss">

</style>
<script>
export default {
  name: "testTab",
  props: {
    taskId: {
      type: String,
      default: ""
    },
    auditType: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      activeName:"accountUnitAnalystAudit"
    }
  },
  components: {
  },
  methods: {

  }
}
</script>
